import { render, staticRenderFns } from "./Page2Pdf4.vue?vue&type=template&id=4dbdf0cb&scoped=true&"
import script from "./Page2Pdf4.vue?vue&type=script&lang=js&"
export * from "./Page2Pdf4.vue?vue&type=script&lang=js&"
import style0 from "./Page2Pdf4.vue?vue&type=style&index=0&id=4dbdf0cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbdf0cb",
  null
  
)

export default component.exports